import { render, staticRenderFns } from "./WaitSign.vue?vue&type=template&id=208530d1&scoped=true"
import script from "./WaitSign.vue?vue&type=script&lang=js"
export * from "./WaitSign.vue?vue&type=script&lang=js"
import style0 from "./WaitSign.vue?vue&type=style&index=0&id=208530d1&prod&lang=css"
import style1 from "./WaitSign.vue?vue&type=style&index=1&id=208530d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208530d1",
  null
  
)

export default component.exports